import React from "react";
import { ArrowLeft, Shield, Mail, Phone } from "lucide-react";
import { useNavigate } from "react-router-dom";

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-cream-light py-20">
      <div className="max-w-4xl mx-auto px-4">
        {/* Header with back button */}
        <div className="mb-8">
          <button
            onClick={() => navigate('/')}
            className="flex items-center space-x-2 text-sage-medium hover:text-gold-warm transition-colors duration-200 mb-6"
          >
            <ArrowLeft className="w-5 h-5" />
            <span>Voltar ao Início</span>
          </button>
          
          <div className="text-center mb-8">
            <div className="bg-gold-warm/20 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
              <Shield className="w-8 h-8 text-gold-warm" />
            </div>
            <h1 className="text-4xl md:text-5xl font-playfair font-bold text-sage-dark mb-4">
              Política de Privacidade
            </h1>
            <p className="text-lg text-sage-medium">
              Na Fonte de Juvence, respeitamos a sua privacidade e protegemos os seus dados pessoais
            </p>
          </div>
        </div>

        {/* Content */}
        <div className="bg-white rounded-3xl shadow-lg p-8 md:p-12">
          <div className="prose prose-lg max-w-none">
            <p className="text-sage-medium leading-relaxed mb-8">
              Na <strong className="text-sage-dark">Fonte de Juvence</strong>, respeitamos a sua privacidade e estamos comprometidos em proteger os seus dados pessoais, 
              em conformidade com o <strong className="text-sage-dark">Regulamento Geral de Proteção de Dados (RGPD – Regulamento (UE) 2016/679)</strong> e a legislação nacional aplicável.
            </p>

            <div className="space-y-8">
              <section>
                <h3 className="text-2xl font-playfair font-bold text-sage-dark mb-4">1. Recolha de Dados</h3>
                <p className="text-sage-medium mb-4">Podemos recolher os seguintes dados pessoais quando utiliza os nossos serviços ou entra em contacto connosco:</p>
                <ul className="space-y-2 text-sage-medium">
                  <li className="flex items-center space-x-2">
                    <div className="w-2 h-2 bg-gold-warm rounded-full"></div>
                    <span>Nome completo</span>
                  </li>
                  <li className="flex items-center space-x-2">
                    <div className="w-2 h-2 bg-gold-warm rounded-full"></div>
                    <span>Contacto telefónico ou WhatsApp</span>
                  </li>
                  <li className="flex items-center space-x-2">
                    <div className="w-2 h-2 bg-gold-warm rounded-full"></div>
                    <span>Endereço de e-mail</span>
                  </li>
                  <li className="flex items-center space-x-2">
                    <div className="w-2 h-2 bg-gold-warm rounded-full"></div>
                    <span>Preferências de serviços de estética e bem-estar</span>
                  </li>
                </ul>
              </section>

              <section>
                <h3 className="text-2xl font-playfair font-bold text-sage-dark mb-4">2. Finalidade do Tratamento</h3>
                <p className="text-sage-medium mb-4">Os dados recolhidos são utilizados exclusivamente para:</p>
                <ul className="space-y-2 text-sage-medium">
                  <li className="flex items-center space-x-2">
                    <div className="w-2 h-2 bg-gold-warm rounded-full"></div>
                    <span>Gestão de marcações e pedidos de informação</span>
                  </li>
                  <li className="flex items-center space-x-2">
                    <div className="w-2 h-2 bg-gold-warm rounded-full"></div>
                    <span>Comunicação de serviços, campanhas e promoções (com consentimento prévio)</span>
                  </li>
                  <li className="flex items-center space-x-2">
                    <div className="w-2 h-2 bg-gold-warm rounded-full"></div>
                    <span>Cumprimento de obrigações legais e fiscais</span>
                  </li>
                </ul>
              </section>

              <section>
                <h3 className="text-2xl font-playfair font-bold text-sage-dark mb-4">3. Partilha de Dados</h3>
                <p className="text-sage-medium">
                  Não partilhamos os seus dados com terceiros, exceto quando tal seja obrigatório por lei ou necessário para a execução dos serviços contratados.
                </p>
              </section>

              <section>
                <h3 className="text-2xl font-playfair font-bold text-sage-dark mb-4">4. Conservação dos Dados</h3>
                <p className="text-sage-medium">
                  Os dados pessoais serão conservados apenas pelo período necessário para a finalidade a que se destinam ou conforme exigido por lei.
                </p>
              </section>

              <section>
                <h3 className="text-2xl font-playfair font-bold text-sage-dark mb-4">5. Direitos dos Titulares</h3>
                <p className="text-sage-medium mb-4">Nos termos da lei, tem direito a:</p>
                <ul className="space-y-2 text-sage-medium">
                  <li className="flex items-center space-x-2">
                    <div className="w-2 h-2 bg-gold-warm rounded-full"></div>
                    <span>Aceder, corrigir ou atualizar os seus dados pessoais</span>
                  </li>
                  <li className="flex items-center space-x-2">
                    <div className="w-2 h-2 bg-gold-warm rounded-full"></div>
                    <span>Solicitar a eliminação dos seus dados</span>
                  </li>
                  <li className="flex items-center space-x-2">
                    <div className="w-2 h-2 bg-gold-warm rounded-full"></div>
                    <span>Retirar o consentimento para comunicações de marketing</span>
                  </li>
                  <li className="flex items-center space-x-2">
                    <div className="w-2 h-2 bg-gold-warm rounded-full"></div>
                    <span>Reclamar junto da <strong>Comissão Nacional de Proteção de Dados (CNPD)</strong></span>
                  </li>
                </ul>
              </section>

              <section className="bg-sage-soft/20 rounded-2xl p-6">
                <h3 className="text-2xl font-playfair font-bold text-sage-dark mb-4">6. Contacto</h3>
                <p className="text-sage-medium mb-4">Para qualquer questão relacionada com a proteção dos seus dados, pode contactar-nos através de:</p>
                <div className="space-y-3">
                  <div className="flex items-center space-x-3">
                    <Mail className="w-5 h-5 text-gold-warm" />
                    <a href="mailto:fdjbraga@gmail.com" className="text-gold-warm hover:text-gold-deep transition-colors">
                      fdjbraga@gmail.com
                    </a>
                  </div>
                  <div className="flex items-center space-x-3">
                    <Phone className="w-5 h-5 text-gold-warm" />
                    <a href="tel:+351253279717" className="text-gold-warm hover:text-gold-deep transition-colors">
                      +351 253 279 717
                    </a>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>

        {/* Footer navigation */}
        <div className="mt-12 text-center">
          <button
            onClick={() => navigate('/')}
            className="bg-gold-warm text-white px-8 py-4 rounded-full hover:bg-gold-deep transition-all duration-300 transform hover:scale-105 font-semibold"
          >
            Voltar ao Website
          </button>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;